// Use a WeakMap to associate elements with their click-outside event handlers
const clickOutsideHandlers = new WeakMap<Element, (event: MouseEvent) => void>();

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive("click-outside", {
        mounted(el, binding) {
            const handler = function (event: MouseEvent) {
                if (!(el === event.target || el.contains(event.target))) {
                    binding.value(event);
                }
            };
            clickOutsideHandlers.set(el, handler);
            document.body.addEventListener("click", handler);
        },
        unmounted(el) {
            const handler = clickOutsideHandlers.get(el);
            if (handler) {
                document.body.removeEventListener("click", handler);
                clickOutsideHandlers.delete(el);
            }
        },
    });
});
